import { render, staticRenderFns } from "./MarketSettingTaskBilling.vue?vue&type=template&id=ed9fdb3e"
import script from "./MarketSettingTaskBilling.vue?vue&type=script&lang=js"
export * from "./MarketSettingTaskBilling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports